import { render, staticRenderFns } from "./NfreshDeliveryList.vue?vue&type=template&id=d29af4b8&scoped=true&"
import script from "./NfreshDeliveryList.vue?vue&type=script&lang=ts&"
export * from "./NfreshDeliveryList.vue?vue&type=script&lang=ts&"
import style0 from "./NfreshDeliveryList.vue?vue&type=style&index=0&id=d29af4b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29af4b8",
  null
  
)

export default component.exports